import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import logo from "../assets/University Officials/image3.jpg";

const Registrar = () => {
    return (
        <div className="container mt-5 mb-5">
            <Card className="shadow border-0 rounded-4">
                <div className="row g-0">
                    <div className="col-md-4 d-flex align-items-center justify-content-center p-4">
                        <img
                            src={logo}
                            alt="Registrar"
                            className="img-fluid rounded-3 shadow-sm"
                            style={{ maxHeight: '320px', objectFit: 'cover' }}
                        />
                    </div>
                    <div className="col-md-8">
                        <CardBody className="p-4">
                            <CardTitle tag="h4" className="text-center text-primary fw-bold">
                                कुलसचिव
                            </CardTitle>
                            <CardText className="fs-5">
                                <strong>प्रो. संजय गोयल</strong><br />
                                कुलसचिव
                            </CardText>
                            <hr />
                            <CardText className="mt-3">
                                <strong>कार्यालय:</strong><br />
                                संपर्क - 01746-297260<br />
                                ई-मेल - <a href="mailto:registrar@mvsu.ac.in">registrar@mvsu.ac.in</a><br />
                                <strong>अस्थाई परिसर:</strong><br />
                                डॉ. भीम राव अम्बेडकर राजकीय महाविद्यालय,<br />
                                जगदीशपुरा, कैथल (हरियाणा) - 136027
                            </CardText>
                        </CardBody>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default Registrar;
